/**
 * SWR Key 规范与辅助工具
 *
 * 【SWR Key 命名与层级规范 (基于全局 Fetcher 架构)】
 *
 * 1. 数组结构原则
 *    为了配合全局 `globalFetcher` 自动发请求，SWR Key 必须是 `[URL, Params]` 的数组格式。
 *    其中 Params 对象必须包含所有影响接口返回的上下文变量。
 *
 * 2. 全局 Fetcher 支持的格式
 *    格式: `[ 'HTTP_METHOD:API_PATH', { data?: BodyParams, params?: QueryParams } ]`
 *    - 示例 GET: `['GET:/api/public/countries']`
 *    - 示例 POST: `['POST:/api/block/get_product_data', { data: { component_id: '123', currency: 'USD' } }]`
 *
 * 3. 依赖参数（Deps）的黄金法则 (必须放入 Params 中)
 *    - 电商核心变量：价格/商品强相关接口，必须带入 `currency` (对应请求中的 cyy)。如果不带，切换货币时缓存不会刷新！
 *    - 分页变量：无限滚动或分页列表，必须带入 `page` 和 `limit`。
 *    - 状态变量：区分线上/预览，需带入 `status`。
 *
 * 4. 全局缓存清理设计 (退出登录场景)
 *    因为我们使用了 `[URL, Params]` 作为 Key，在退出登录时如果需要清理用户私有缓存：
 *    可以使用 SWR 的正则/函数过滤能力，匹配特定的 API 路径进行全局清空：
 *    `mutate((key) => Array.isArray(key) && typeof key[0] === 'string' && key[0].includes('/api/user/'), undefined, { revalidate: false })`
 *
 * 5. 示例解析 (业务 Hook 中的使用):
 *    ```typescript
 *    const requestParams = {
 *      data: { component_id: id, currency: 'USD' }
 *    };
 *    // 必须使用 serializeKey 进行序列化，保证对象属性乱序时缓存依然能命中
 *    const swrKey = serializeKey(['POST:/api/block/get_product_data', requestParams]);
 *    const { data } = useSWR(swrKey); // 全局 Fetcher 会自动接管
 *    ```
 *
 * 注意：具体的 Key 组装逻辑请下放到各自的业务 Hooks 模块中维护（高内聚）。
 */

// 辅助函数：将复杂 Key 稳定序列化（防止对象顺序不同导致命中失败）
export const serializeKey = (key: readonly any[] | any[] | null) =>
  key ? JSON.stringify(key) : null;
